import store from '@/store/index.js'
export default {
	created(){
		//console.log('this.$store.state',this.$store.state)
		this.$store.commit('changeNowRouteName',this.$route.name)
		//console.log('this.$store.state',this.$store.state)
	},
	mounted(){
		
	}
}



// WEBPACK FOOTER //
// ./src/mixins/page.js